import React from 'react';
import { Users, FileText, Inbox,PackageOpen     } from 'lucide-react';
import NoDataStyles from './NoData.module.css';

const ICON_MAP = {
	users: Users,
	file: FileText,
	inbox: Inbox,
	Database: PackageOpen   
};

const NoData = ({
	icon = 'file',
	title = 'Nothing here yet',
	subTitle = 'There is no data to display.',
	height = '75vh',
}) => {
	const IconComponent = ICON_MAP[icon] || Users;

	return (
		<div className={NoDataStyles.noDataContainer} style={{ height }}>
			<IconComponent
				size={56}
			/>
			<h3 className={NoDataStyles.noDataContainerText}>{title}</h3>
			<p className={NoDataStyles.noDataContainerSubText}>{subTitle}</p>
		</div>
	);
};

export default NoData;
